import { render, staticRenderFns } from "./HostingPagesSidebar.vue?vue&type=template&id=611562fb&scoped=true"
import script from "./HostingPagesSidebar.vue?vue&type=script&lang=js"
export * from "./HostingPagesSidebar.vue?vue&type=script&lang=js"
import style0 from "./HostingPagesSidebar.scss?vue&type=style&index=0&id=611562fb&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "611562fb",
  null
  
)

export default component.exports